import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { OrganisationWithJobTitles } from '@src/api';
import { JobTitlesPipe } from '@src/app/shared/pipes';
import { OrganisationJobTitleUI, UserUI } from '@src/models';
import { ObjectId } from '@src/types/id';

@Component({
  selector: 'new-list-item-user',
  templateUrl: './list-item-user.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemUserComponent {
  private readonly jobTitlesPipe = inject(JobTitlesPipe);
  private readonly translateService = inject(TranslateService);

  @Input() set item(data: UserUI | undefined) {
    this.data = data;

    this.editDateNormalize = this.getDateNormalize(data?.dateEdited);
  }

  @Input() selectedId: ObjectId;
  @Input() loading?: boolean;

  data?: UserUI;

  editDateNormalize?: string;

  get jobTitles(): OrganisationWithJobTitles[] | OrganisationJobTitleUI[] {
    let organisationJobTitles: OrganisationWithJobTitles[] | OrganisationJobTitleUI[] = [];

    if (this.data) {
      // TODO: refactoring
      if ('jobTitlesInOrganisation' in this.data && this.data.jobTitlesInOrganisation) {
        organisationJobTitles = this.data.jobTitlesInOrganisation as OrganisationWithJobTitles[];
      } else if ('organisationJobTitles' in this.data && this.data.organisationJobTitles) {
        organisationJobTitles = this.jobTitlesPipe.transform(this.data.organisationJobTitles);
      }
    }

    const organisationWithJobTitles: OrganisationWithJobTitles[] = [];
    organisationJobTitles.forEach(organisationJobTitle => {
      if (
        !!organisationWithJobTitles.find(
          organisation => organisation.organisationId === organisationJobTitle.organisationId,
        )
      )
        return;
      organisationWithJobTitles.push(organisationJobTitle);
    });

    return organisationWithJobTitles ?? [];
  }

  private getDateNormalize(dateEdited?: string): string {
    if (!dateEdited) return '';

    const date = new Date(dateEdited);

    const normalizedDate = formatDate(date, 'dd MMMM', this.translateService.instant('languageCode'), 'UTC');
    const time = formatDate(date, 'HH:mm', 'en', 'UTC');

    return this.translateService.instant('components.listItemUsers.labels.editedDate', {
      date: normalizedDate,
      time,
    });
  }
}
